$(function () {
    const showQuestions = (faqList) => {
        const accordionItems = faqList.querySelectorAll('.accordion-item.d-none');
        accordionItems.forEach((faqItem) => {
            faqItem.classList.remove('d-none');
        });
    };

    const CreateShowMoreLink = () => {
        var wrapper = document.createElement('div');
        wrapper.className = 'text-center  m-auto';
        var a = document.createElement('a');
        a.href = '#';
        a.className = 'btn btn-primary';
        var link = document.createTextNode('Visa alla');
        a.appendChild(link);
        wrapper.appendChild(a);
        a.addEventListener('click', function (e) {
            e.preventDefault();
            showQuestions(e.currentTarget.parentNode.parentNode);
            e.target.remove();
        });
        return wrapper;
    };

    const hideQuestions = () => {
        var accordions = document.querySelectorAll('.accordion.faq-accordion');
        if (accordions != null) {
            accordions.forEach((faq) => {
                const accordionItems = faq.querySelectorAll('.accordion-item');

                if (accordionItems.length > 5) {
                    for (let i = 5; i < accordionItems.length; i++) {
                        accordionItems[i].classList.add('d-none');
                    }

                    const link = CreateShowMoreLink();
                    faq.insertAdjacentElement('afterEnd', link);
                }
            });
        }
    };

    hideQuestions();
});
